import React from "react";
import { formatNumberCOP } from "../../../utilities/app.utilities";
const NumericLabel = ({ value }) => {
  return <label>{formatNumberCOP(value)}</label>;
};

export default NumericLabel;
